import { api } from './base';

import { MutationArg } from 'v2/types';
import { SpecialDropModel, SpecialDropRequest } from 'v2/types/SpecialDropModel';
import { SWRKeyValue } from 'v2/types/swr';

const SPECIAL_DROP_URL = 'admin/special-drop';

export const specialDropService = {
  getSpecialDrops(): Promise<SpecialDropModel[]> {
    return api.get(SPECIAL_DROP_URL).json();
  },

  createSpecialDrop(_key: string, { arg }: MutationArg<SpecialDropRequest>): Promise<SpecialDropModel> {
    return api.post(SPECIAL_DROP_URL, { json: arg }).json();
  },

  updateSpecialDrop(
    [_key, specialDropId]: SWRKeyValue,
    { arg }: MutationArg<SpecialDropRequest>
  ): Promise<SpecialDropModel> {
    return api.put(`${SPECIAL_DROP_URL}/${specialDropId}`, { json: arg }).json();
  },

  deleteSpecialDrop([_key, specialDropId]: SWRKeyValue): Promise<void> {
    return api.delete(`${SPECIAL_DROP_URL}/${specialDropId}`).json();
  },
};
